import { create } from "zustand";
import { IssuesState } from "../_types/issues.types";

export const useIssuesStore = create<IssuesState>((set) => ({
  type: "all",
  period: "all",
  status: "all",
  page: 1,
  limit: 10,
  setType: (type) => set({ type, page: 1 }),
  setPeriod: (period) => set({ period, page: 1 }),
  setStatus: (status) => set({ status, page: 1 }),
  setPage: (page) => set({ page }),
  setLimit: (limit) => set({ limit, page: 1 }),
}));
